import { IRootState } from '../../app/store';

export const selectAllActiveSkillAsyncStatus = (state: IRootState) =>
    state.searchContent.asyncStatus;
export const selectAllActiveSkillsDetails = (state: IRootState) =>
    state.searchContent.activeSkillsDetails;
export const selectAllSkillStatusCode = (state: IRootState) =>
    state.searchContent.statusCode;
export const selectAllActiveCourseIdentifierSkills = (state: IRootState) =>
    (state.searchContent?.activeSkillsDetails || [])?.map(
        (skill) => skill?.courseIdentifier
    );

export const selectHSearchSkillAsyncStatus = (state: IRootState) =>
    state.searchContent.asyncHSearchStatus;
export const selectHSearchSkillsDetails = (state: IRootState) =>
    state.searchContent.hSearchSkillsDetails;
export const selectHSearchFacetData = (state: IRootState) =>
    state.searchContent.hSearchFacetData;
export const selectHSearchSkillStatusCode = (state: IRootState) =>
    state.searchContent.hSearchStatusCode;
export const selectHSearchSkillNumRows = (state: IRootState) =>
    state.searchContent.hSearchTotalRows;
export const selectAddOrEditFavoriteFiltersAsyncStatus = (state: IRootState) =>
    state.searchContent.asyncAddOrEditFavoriteFiltersStatus;
export const selectAddOrEditFavoriteFiltersStatusCode = (state: IRootState) =>
    state.searchContent.addOrEditFavoriteFilterStatusCode;
export const selectGetFavoriteFiltersAsyncStatus = (state: IRootState) =>
    state.searchContent.asyncGetFavoriteFiltersStatus;
export const selectGetFavoriteFiltersStatusCode = (state: IRootState) =>
    state.searchContent.getFavoriteFilterStatusCode;
export const selectFavoriteFilters = (state: IRootState) =>
    state.searchContent.favoriteFilters;
export const selectHSCSContentAsyncStatus = (state: IRootState) =>
    state.searchContent.hscsAsyncStatus;
export const selectHscsContentDetails = (state: IRootState) =>
    state.searchContent.hscsContentDetails;
export const selectHscsStatusCode = (state: IRootState) =>
    state.searchContent.hscsContentStatusCode;
export const selectQuickLinksAsyncStatus = (state: IRootState) =>
    state.searchContent.quickLinksAsyncStatus;
export const selectQuickLinks = (state: IRootState) =>
    state.searchContent.quickLinks;
export const selectQuickLinksStatusCode = (state: IRootState) =>
    state.searchContent.quickLinksStatusCode;
export const selectPEAutoSuggestStatus = (state: IRootState) =>
    state.searchContent.peAutoSuggestStatus;
export const selectPEAutoSuggestData = (state: IRootState) =>
    state.searchContent.peAutoSuggestData;
export const selectRecentViewedSkillsAsyncStatus = (state: IRootState) =>
    state.searchContent.recentViewedSkillsAsyncStatus;
export const selectRecentViewedSkills = (state: IRootState) =>
    state.searchContent.recentViewedSkills;
export const selectRecentViewedSkillsStatusCode = (state: IRootState) =>
    state.searchContent.recentViewedSkillsStatusCode;
export const selectKeywordAutoSuggestStatus = (state: IRootState) =>
    state.searchContent.keywordAutoSuggestStatus;
export const selectKeywordAutoSuggestData = (state: IRootState) =>
    state.searchContent.keywordAutoSuggestData;
export const selectSearchPageState = (state: IRootState) =>
    state.searchContent.searchPageState;
export const selectIsNavigatingBackToSearch = (state: IRootState) =>
    state.searchContent.isNavigatingBackToSearch;
